import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       action
 * @param       showAlert -  show alert
 * @param       setOpenVariable
 * @param       variables
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function AddParagraph({ action, showAlert, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const [fontType, setFontType] = useState([]);
    const [color, setColor] = useState([]);

    const label = 'CONTENT.CONFIGURATION-FORM.WORD.ADD-PARAGRAPH.';

    const fontTypeOptions = [
        { name: "Bold", value: "b" },
        { name: "Italic", value: "i" },
        { name: "Underline", value: "u" }
    ]

    useEffect(() => {
        if (!action.fields.fontType)
            action.fields.fontType = { value: [], type: 'ARRAY' };
        else
            setFontType(action.fields.fontType.value)

    }, [action])

    function handleFontType(value) {
        setFontType(value);
        action.fields.fontType.value = value;
    }

    return (
        <div>
            <div className="form-element">
                <div className="form-element">
                    {t(label + 'WORD-SOURCE')}
                    <VariablePicker action={action} inputName="wordSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="array" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
                </div>
            </div>
            <div className="form-element">
                {t(label + 'PARAGRAPH-DATA')}
                <TextInput action={action} inputName="paragraphData" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired={true} multiline />
            </div>
            <div className="form-element">
                {t(label + "FONT-TYPE")}
                <Autocomplete
                    multiple
                    id="tags-outlined"
                    options={fontTypeOptions}
                    getOptionLabel={(option) => option.name}
                    value={fontType}
                    getOptionSelected={(option, value) => option.name === value.name}
                    onChange={(event, value) => handleFontType(value)}
                    filterSelectedOptions
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            placeholder={t(label + "FONT-TYPE")}
                        />
                    )}
                />
            </div>
            <div className="form-element">
                {t(label + 'COLOR')}
                <TextInput action={action} inputName="color" variables={variables}
                    setOpenVariable={setOpenVariable} />
                <small><em>{t(label + 'COLOR-HEX-COMMENT')}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'FONT-SIZE')}
                <TextInput action={action} inputName="fontSize" variables={variables}
                    setOpenVariable={setOpenVariable} />
                <small><em>{t(label + 'FONT-SIZE-COMMENT')}</em></small>
            </div>
        </div>
    )
}

export default AddParagraph;
